import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import FindLanguage from '../../i18n_custom';

export default function PlannedIncidentItem({ item }) {
  const { t, i18n } = useTranslation();
  const formattedStartDate = format(new Date(item.scheduled_for), 'dd.MM.yyyy, HH:mm');
  const formattedEndDate = format(new Date(item.scheduled_until), 'dd.MM.yyyy, HH:mm');
  
  // Assigns the first update (which gets pushed), to the incidentUpdate, this until this one
  // is fixed: https://community.atlassian.com/t5/Statuspage-questions/Keeping-maintenance-message-from-scheduled-to-ongoing/qaq-p/1879278?utm_source=atlcomm&utm_medium=email&utm_campaign=accept_as_solution_reminder&utm_content=topic
  let incidentUpdate = item.incident_updates
    .filter((e) => {
      if (e.status == 'scheduled') {
        return e;
      }
    });
  incidentUpdate = incidentUpdate[0].body;
  
  return (
    <li>
      <div className='dnb-planned-incident__time'>
        <time dateTime={item.scheduled_for}>{formattedStartDate}</time>
        <span> - </span>
        <time dateTime={item.scheduled_until}>{formattedEndDate}</time>
      </div>
      <h3>{FindLanguage(item.name)}</h3>
      <p>{FindLanguage(incidentUpdate)}</p>
    </li>
  );
}

PlannedIncidentItem.propTypes = {
  item: PropTypes.object,
};
